import React, { useState, useEffect, useRef } from "react";
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TablePagination,
    Paper,
    Button,
    Dialog,
    Grid,
    Box,
    DialogActions,
    DialogContent,
    DialogContentText,
    Divider,
    TextField,
    FormControl,
} from "@material-ui/core";
import { connect } from "react-redux";
import { setLoading, setSnackInfo } from "../../redux/actions/appAction";
import { CSVLink } from "react-csv";
import { Modal } from "antd";
import { makeStyles, useTheme, withStyles } from "@material-ui/core/styles";
import moment from "moment";
import MenuItem from "@material-ui/core/MenuItem/MenuItem";
import HttpService from "../../services/httpService";
import Autocomplete from '@material-ui/lab/Autocomplete';
import DetailsModalOfInwarding from "../../components/DetailsModalOfInwarding";

const useStyles = makeStyles((theme) => ({
    table: {
        minWidth: 850,
    },
    textField: {
        width: 100,
    },
    paper: {
        padding: theme.spacing(2),
        margin: "auto",
        maxWidth: 400,
    },
    actionButton: {
        backgroundColor: "#F47E46", // Primary background color
        color: "#FFF2EB",          // Primary text color
        "&:hover": {
            backgroundColor: "#E36F3E", // Darkened version of #F47E46
            color: "#FFD9C7",           // Lightened version of #FFF2EB
        }
    },
    submitButton: {
        backgroundColor: '#F47E46 !important',  // Decorpot Orange
        color: 'white',            // White text
        '&:hover': {
            backgroundColor: '#E0663D !important', // Darker Orange on hover
        },
    },
    clearButton: {
        backgroundColor: '#FFF2EB !important',   // Light Beige
        color: '#1C375D !important',             // Decorpot Orange text
        '&:hover': {
            backgroundColor: '#E7BAD0 !important', // Light Pink on hover
        },
    },
}));

const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: "#1C375D",
        color: '#FFF2EB',
        fontWeight: "500"
    },
    body: {
        fontSize: 14,
        // border: '1px solid red'
    },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
    root: {
        "&:nth-of-type(odd)": {
            backgroundColor: theme.palette.action.hover,
        },
    },
}))(TableRow);

const NewInwardingApproval = (props) => {
    const [dataForNewInwardingApproval, setDataForNewInwardingApproval] =
        useState([]);
    const [openDialog, setOpenDialog] = useState(false);
    const [value, setValue] = useState("");
    const [details, setDetails] = useState([]);
    const classes = useStyles();
    const [textContent, setTextContent] = useState("");
    const [procurementDetails, setProcurementDetails] = useState({});
    const [invoiceModal, setInvoiceModal] = useState(false);
    const [material, setMaterial] = useState({});
    const [index, setIndex] = useState(null);
    const [updatedMat, setUpdatedMat] = useState(0);
    const [transportationCharge, setTransportationCharge] = useState(0);
    const [freightCharge, setFreightCharge] = useState(0);
    const [gstAmounts, setGstAmounts] = useState(0);
    const [gstOrginalAmount, setGstOriginalAmount] = useState(0);
    const [isGstUpdated, setIsGstUpdated] = useState(false);
    const [isUpdated, setIsUpdated] = useState({
        valuesUpdated: false,
    });
    const [isMaterialUpdated, setIsMaterialUpdated] = useState(false);
    const [materialOriginalPrice, setMaterialOriginalPrice] = useState([]);
    const [editableFields, setEditableFields] = useState({
        transportationCharge: transportationCharge,
        gstAmounts: gstAmounts,
        freightCharge: freightCharge,
    });
    const [selectedOrderId, setSelectedOrderId] = useState("");
    const [openApproveRemarksModal, setOpenApproveRemarksModal] =
        useState(false);
    const [openRejectRemarksModal, setOpenRejectRemarksModal] = useState(false);
    const [remarks, setRemarks] = useState("");
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [csvData, setCsvData] = useState([]);
    const csvButtonRef = useRef(null);
    const [approvedProjects, setApprovedProjects] = useState([]);
    const [rejectionReason, setRejectionReason] = useState("");
    const [openAllRemarksDailog, setOpenAllRemarksDailog] = useState(false);
    const [freightGstDetails, setFreightGstDetails] = useState({ type: "", rate: "0" });
    const [freightChargeWOGst, setFreightChargeWOGst] = useState(0);
    const freightGstPercent = ["0", "5", "12", "18", "28"];
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(100);
    const [totalCount, setTotalCount] = useState(0);
    const [searchType, setSearchType] = useState(""); // Default to PO search
    const [searchQuery, setSearchQuery] = useState("");
    const [filterType, setfilterType] = useState("Pending");
    

    /*
    // Function to handle the change in GST Rates
    const freightGstRateChangeHandler = (event, value) => {
        setFreightGstDetails({ ...freightGstDetails, rate: value });
        // Calculate the percentage amount and add it to freightCharge
        let freightChargeWithGst = freightChargeWOGst + (+freightChargeWOGst * +value) / 100;
        setFreightCharge(freightChargeWithGst.toFixed(2));
        const procDetailObj = { ...procurementDetails };
        procDetailObj.grandTotal =
            procDetailObj?.grandTotal - freightCharge + +freightChargeWithGst;
        // procDetailObj.freight = +event.target.value;

        setProcurementDetails(procDetailObj);
        setEditableFields({
            ...editableFields,
            freightCharge: +freightChargeWithGst,
        });
        // const procurementObj = { ...procurementDetails };
        // procurementDetails.gstDetails[0].rate = value;
        // priceCal(details.materialIdOfInwarding._id, procurementDetails, details);
        // setProcurementDetails(procurementObj);
    }
    */

    // Headers to for csv
    const headers = [
        { key: "orderId", label: "PO No." },
        { key: "inwardingId", label: "Inwarding Id" },
        { key: "inwardedDate", label: "Inwarded Date" },
        { key: "invoiceDate", label: "Invoice Date" },
        { key: "invoiceNumber", label: "Invoice N0" },
        { key: "poQty", label: "PO Qty" },
        { key: "inwardedQty", label: "Inwarded Qty" },
        { key: "gst", label: "GST" },
        { key: "freightCharges", label: "freightCharges" },
        { key: "DateOfApproval", label: "DateOfApproval" },
        { key: "totalValue", label: "Total Value" },
        { key: "Status", label: "Status" },
    ];

    /*
    // Function to open invoice Modal
    const openInvoiceModalHelper = (materialId, data, value) => {
        setInvoiceModal(true);
        priceCal(materialId, data, value);
        setMaterial(
            procurementDetails?.materials?.filter(
                (material) => material?.materialId?._id === materialId
            )[0]
        );
        // setIndex(i)
    };
    */

    useEffect(() => {
        getDataForInwardingApprovals(startDate, endDate, page, rowsPerPage);
    }, [page, rowsPerPage, startDate, endDate]);

    // Function to get procurement Details based on the click on action button
    const openInvoiceModalHandler = async (value) => {
        setSelectedOrderId(value?.procurementId?.orderId);
        // setValue(value);
        setDetails(value);
        props.setLoading(true);
        try {
            setInvoiceModal(true);
            /*
            const result =
                await HttpService.getProcurementByOrderIdForInwarding(
                    value?.procurementId?.orderId
                );
            setProcurementDetails(result.data);
            let arr = result?.data?.materials?.map((el) => el.requestedPrice);
            setMaterialOriginalPrice(arr);
            // setOpenDialog(true)
            openInvoiceModalHelper(
                value?.materialIdOfInwarding?._id,
                result.data,
                value
            );
            */
        } catch (error) {
            console.error(error);
            // props.setSnackInfo(error?.response?.data ?? "Something went wrong", "error")
        }
        props.setLoading(false);
    };

    // function to get inwarding data sent for inwarding approvals
    const getDataForInwardingApprovals = async (
        startDate,
        endDate,
        page = 0,
        rowsPerPage = 100,
        searchType,searchQuery
    ) => {
        props.setLoading(true);
        try {
            const response = await HttpService.getDataForNewInwardingApproval(
                startDate,
                endDate,
                page,
                rowsPerPage,searchType,searchQuery
            );
            setDataForNewInwardingApproval(response.data.data);
            setTotalCount(response.data.totalCount);
        } catch (err) {
            props.setSnackInfo(
                err?.response?.data ?? "Something went wrong",
                "error"
            );
        }
        props.setLoading(false);
    };

    // Function to handle remarks input
    const remarksInputHandler = async (e) => {
        setRemarks(e.target.value);
        // if (e.target.value.trim() === "") return props.setSnackInfo("Please Enter Remarks", "error");
    };

    /*
    // A helper function to calculate the necessary fields when rate, gst, freight, or transportation charges are changed
    const priceCal = (materialId, data, value) => {
        let total = 0;
        let subTotal = 0;
        let presicionDiff = 0;
        let toatlGstAmount = 0;
        let totalQty = 0;
        data.materials.forEach((mat) => {
            if (
                mat.materialId._id.toString() === materialId.toString() &&
                mat?.materialId?._id?.toString() ===
                    value?.materialIdOfInwarding?._id?.toString()
            ) {
                // mat.materialTotal = +mat.requestedQuantity * +mat.requestedPrice || +mat.materialId.pricePerUnit;
                mat.materialTotal =
                    +value?.InwardingRecords?.inwardedQty *
                        +mat.requestedPrice || +mat.materialId.pricePerUnit;
                total += mat.materialTotal;
                // totalQty += mat.requestedQuantity;
                totalQty += +value?.InwardingRecords?.inwardedQty;
                mat.isAdded = true;
            }
        });

        if (data.discount) {
            // total = total - data.discount;
            let discountAmount = (data.discount / 100) * total; // Calculate the discount amount
            total -= discountAmount;
        } else {
            data.discount = 0;
        }
        subTotal = total;

        if (data.gstRequired) {
            data.gstDetails.forEach((gstDetail) => {
                gstDetail.gstAmount = Number(
                    Number.parseFloat((gstDetail.rate * total) / 100).toFixed(2)
                );
                toatlGstAmount += gstDetail.gstAmount;
            });
            total = total + toatlGstAmount;
        } else {
            toatlGstAmount = 0;
        }

        if (value.InwardingRecords.freightCharge) {
            total = total + +value.InwardingRecords.freightCharge;
        } else {
            data.freight = 0;
        }

        if (data.transportationCharge) {
            total = total + data.transportationCharge;
        } else {
            data.transportationCharge = 0;
        }

        data.totalQty = +totalQty;
        data.subTotal = +subTotal;
        data.grandTotal = +total;
        presicionDiff =
            Number(total).toFixed(2) -
            Number(Number.parseFloat(subTotal).toFixed(2)) -
            Number(Number.parseFloat(toatlGstAmount).toFixed(2)) +
            Number(Number.parseFloat(data.discount).toFixed(2)) -
            Number(Number.parseFloat(data.transportationCharge).toFixed(2)) -
            Number(Number.parseFloat(data.freight).toFixed(2));
        data.presicionDiff = Number.parseFloat(presicionDiff).toFixed(2);
        // let word = numWords(Math.round(+procurementDetails.grandTotal));
        // procurementDetails.amountInWords = word.toUpperCase();
        setTransportationCharge(data?.transportationCharge);
        setFreightCharge(value.InwardingRecords.freightCharge);
        setFreightChargeWOGst(value.InwardingRecords.freightCharge);
        setGstAmounts(toatlGstAmount);
        setEditableFields({ ...editableFields, gstAmounts: data?.gstDetails });
        setUpdatedMat(data.grandTotal);
        setProcurementDetails(data);
        return data;
    };
    */

    /*
      const handleInputChange = (field, value) => {
          setIsUpdated({ valuesUpdated: true });
          if (field === "transportationCharge") {
              setTransport(value);
              procurementDetails.grandTotal = (procurementDetails?.grandTotal - transport) + +value;
              setEditableFields({ ...editableFields, [field]: +value });
          } else if (field === "freightCharge") {
              setFreight(value);
              procurementDetails.grandTotal = (procurementDetails?.grandTotal - freight) + +value;
              setEditableFields({ ...editableFields, [field]: +value });
          } else if (field === "Gst") {
              setIsGstUpdated(true)
              setGstAmounts(value);
              let val = (value / procurementDetails?.grandTotal) * 100;
              procurementDetails.grandTotal = (procurementDetails?.grandTotal - gstAmounts) + +value;
              setEditableFields({ ...editableFields, gstAmounts: +val.toFixed(0) });
          }
      };
      */

    /*
      function handleMaterialPriceChange(index, newPrice) {
          setIsMaterialUpdated(true)
          procurementDetails.materials[index].requestedPrice = newPrice;
  
          let total = 0;
          let subTotal = 0;
          let presicionDiff = 0;
          let toatlGstAmount = 0;
          let totalQty = 0;
  
          procurementDetails.materials.forEach(mat => {
              if (mat.isAdded === true) {
                  mat.materialTotal = +mat.requestedQuantity * +mat.requestedPrice || +mat.materialId.pricePerUnit;
                  total += mat.materialTotal;
                  totalQty += mat.requestedQuantity;
  
              }
          })
  
          if (procurementDetails.discount) {
              total = total - procurementDetails.discount;
          } else {
              procurementDetails.discount = 0;
          }
          subTotal = total;
          if (procurementDetails.freight) {
              total = total + procurementDetails.freight;
          } else {
              procurementDetails.freight = 0;
          }
  
          if (procurementDetails.gstRequired) {
              procurementDetails.gstDetails.forEach(gstDetail => {
                  gstDetail.gstAmount = Number(Number.parseFloat((gstDetail.rate * total) / 100).toFixed(2));
                  toatlGstAmount += gstDetail.gstAmount;
              })
              total = total + toatlGstAmount;
          } else {
              toatlGstAmount = 0;
          }
  
          if (procurementDetails.transportationCharge) {
              total = total + procurementDetails.transportationCharge;
          } else {
              procurementDetails.transportationCharge = 0;
          }
  
          procurementDetails.totalQty = +totalQty;
          procurementDetails.subTotal = +subTotal;
          procurementDetails.grandTotal = +total;
          presicionDiff = (Math.round(total) - Number(Number.parseFloat(subTotal).toFixed(2)) - Number(Number.parseFloat(toatlGstAmount).toFixed(2)) + Number(Number.parseFloat(procurementDetails.discount).toFixed(2)) - Number(Number.parseFloat(procurementDetails.transportationCharge).toFixed(2)) - Number(Number.parseFloat(procurementDetails.freight).toFixed(2)));
          procurementDetails.presicionDiff = Number.parseFloat(presicionDiff).toFixed(2);
          setTransport(procurementDetails?.transportationCharge)
          setFreight(procurementDetails?.freight)
          setGstAmounts(toatlGstAmount)
          setEditableFields({ ...editableFields, gstAmounts: procurementDetails?.gstDetails });
          setUpdatedMat(procurementDetails.grandTotal)
          return procurementDetails;
      }
  
      */

    // Function to handle the action of finance the procurement status when it is submitted
    const handleFinanceInwardingAction = async () => {
        // Set loading state to true to indicate a process is ongoing
        props.setLoading(true);

        // Check if remarks are entered, if not show a warning and return
        if (remarks.trim().length === 0) {
            props.setSnackInfo(
                `Please Enter ${textContent} Remarks Before Submitting`,
                "warning"
            );
            props.setLoading(false);
            return;
        }

        // Create an object to hold the updated procurement details and status
        let updateObj = {
            status: value,
            remarks: remarks.trim(),
            freightCharge: freightCharge,
            freightChargeWOGst: freightChargeWOGst,
            freightGstDetails: freightGstDetails,
            ...details,
        };

        // If values have been updated, include price and GST modify the information in object
        if (isUpdated.valuesUpdated === true) {
            updateObj.isPricesUpdated = true;
            updateObj.isGstUpdated = isGstUpdated;
            updateObj.fields = editableFields;
        }

        // If materials have been updated, include the updated materials information
        if (isMaterialUpdated === true) {
            updateObj.isMaterialUpdated = isMaterialUpdated;
            updateObj.materials = procurementDetails?.materials;
        }

        try {
            // Send the finance action status request to the backend API
            const response = await HttpService.updateFinanceStatus(updateObj);

            // Display success message if the response was successful
            props.setSnackInfo(
                response?.data?.msg ?? "Updated Successfully",
                response?.data?.type ?? "success"
            );
        } catch (err) {
            console.error("Error -> ", err);

            // Display error message if something went wrong
            props.setSnackInfo(
                err?.response?.data?.msg ?? "Something went wrong",
                err?.response?.type ?? "error"
            );
        }

        // Close the remarks modal and reset remarks input
        setOpenApproveRemarksModal(false);
        setOpenRejectRemarksModal(false);
        setRejectionReason("");
        setRemarks("");

        // Close the invoice modal
        setInvoiceModal(false);

        // Set loading state to false to indicate the process has completed
        props.setLoading(false);

        // Refresh data for inwarding approvals
        getDataForInwardingApprovals(startDate, endDate, page, rowsPerPage,searchType,searchQuery);
    };

    /*
    // function to handle price change of material
    const materialPriceChangeHandler = (index, event) => {
        // Log the index and the new value
        if (+event.target.value <= 0)
            return props.setSnackInfo(
                "Please Enter Value Greater than 0",
                "warning"
            );

        // Set isMaterialUpdated to true
        setIsMaterialUpdated(true);
        setFreightGstDetails({ ...freightGstDetails, rate: 0 });

        // Log the original material price

        // Check if the new price is greater than the original requested price
        if (+event.target.value > +materialOriginalPrice[index]) {
            // Display an error message and return if the new price is greater
            props.setSnackInfo(
                "New Rate can't be greater than original Requested Rate",
                "error"
            );
            return;
        }
        // Create a copy of procurementDetails
        const updatedProcurementDetails = { ...procurementDetails };
        // Update the requested price for the material at the specified index
        updatedProcurementDetails.materials[index].requestedPrice =
            event.target.value;

        // Initialize variables for calculations
        let total = 0;
        let subTotal = 0;
        let presicionDiff = 0;
        let toatlGstAmount = 0;
        let totalQty = 0;

        // Calculate total and total quantity for all materials
        updatedProcurementDetails.materials.forEach((mat, i) => {
            if (mat.isAdded === true) {
                // mat.materialTotal = +mat.requestedQuantity * +mat.requestedPrice || +mat.materialId.pricePerUnit;
                mat.materialTotal =
                    +details?.InwardingRecords?.inwardedQty *
                        +mat.requestedPrice || +mat.materialId.pricePerUnit;
                total += mat.materialTotal;
                // totalQty += mat.requestedQuantity;
                totalQty += details?.InwardingRecords?.inwardedQty;
            }
        });

        // Calculate subTotal
        if (updatedProcurementDetails.discount) {
            // total = total - updatedProcurementDetails.discount;
            let discountAmount =
                (updatedProcurementDetails.discount / 100) * total; // Calculate the discount amount
            total -= discountAmount;
        } else {
            updatedProcurementDetails.discount = 0;
        }
        subTotal = total;

        // Calculate GST amounts
        if (updatedProcurementDetails.gstRequired) {
            updatedProcurementDetails.gstDetails.forEach((gstDetail) => {
                gstDetail.gstAmount = Number(
                    Number.parseFloat((gstDetail.rate * total) / 100).toFixed(2)
                );
                toatlGstAmount += gstDetail.gstAmount;
            });
            total = total + toatlGstAmount;
        } else {
            toatlGstAmount = 0;
        }

        // Calculate total with freight
        if (details.InwardingRecords.freightCharge) {
            total = total + details.InwardingRecords.freightCharge;
        } else {
            updatedProcurementDetails.freight = 0;
        }

        // Calculate total with transportation charge
        if (updatedProcurementDetails.transportationCharge) {
            total = total + updatedProcurementDetails.transportationCharge;
        } else {
            updatedProcurementDetails.transportationCharge = 0;
        }

        // Update procurementDetails with calculated values
        updatedProcurementDetails.totalQty = +totalQty;
        updatedProcurementDetails.subTotal = +subTotal;
        updatedProcurementDetails.grandTotal = +total;
        presicionDiff =
            Number(total)?.toFixed(2) -
            Number(Number.parseFloat(subTotal).toFixed(2)) -
            Number(Number.parseFloat(toatlGstAmount).toFixed(2)) +
            Number(
                Number.parseFloat(updatedProcurementDetails.discount).toFixed(2)
            ) -
            Number(
                Number.parseFloat(
                    updatedProcurementDetails.transportationCharge
                ).toFixed(2)
            ) -
            Number(
                Number.parseFloat(updatedProcurementDetails.freight).toFixed(2)
            );
        updatedProcurementDetails.presicionDiff =
            Number.parseFloat(presicionDiff).toFixed(2);

        // Update state with new values
        setTransportationCharge(
            updatedProcurementDetails?.transportationCharge
        );
        setFreightCharge(details.InwardingRecords.freightCharge);
        setFreightChargeWOGst(details.InwardingRecords.freightCharge);
        setGstAmounts(toatlGstAmount);
        setGstOriginalAmount(toatlGstAmount);
        setEditableFields({
            ...editableFields,
            gstAmounts: updatedProcurementDetails?.gstDetails,
        });
        setUpdatedMat(updatedProcurementDetails.grandTotal);

        // Update the requested price for the material at Inwarding approvals
        setDetails((prevState) => ({
            ...prevState,
            InwardingRecords: {
                ...prevState.InwardingRecords,
                inwardedRate: event.target.value,
            },
        }));

        // updating the procurementDetails
        setProcurementDetails(updatedProcurementDetails);

        // Return the updated procurementDetails
        // return updatedProcurementDetails;
    };

    // function to handle change in GST 
    const gstChangeHandler = (event) => {
        if (+event.target.value > +gstOrginalAmount) {
            return props.setSnackInfo(
                "GST Amount can't be greater than Requested GST Amount",
                "error"
            );
        }
        setGstAmounts(event.target.value);
        setIsGstUpdated(true);
        let val = (+event.target.value / procurementDetails?.grandTotal) * 100;
        procurementDetails.grandTotal =
            procurementDetails?.grandTotal - gstAmounts + +event.target.value;
        setEditableFields({ ...editableFields, gstAmounts: +val.toFixed(0) });
    };

    // function to handle change in transportation charges
    const transportationChargesChangeHandler = (event) => {
        setTransportationCharge(event.target.value);
        procurementDetails.grandTotal =
            procurementDetails?.grandTotal -
            transportationCharge +
            +event.target.value;
        setEditableFields((prevState) => ({
            ...editableFields,
            transportationCharge: +event.target.value,
        }));
    };

    // function to handle change in freight charges
    const freightChargesChangeHandler = (event) => {
        if (+event.target.value <= 0)
            return props.setSnackInfo(
                "Please Enter Value Greater than 0",
                "warning"
            );
        setFreightCharge(+event.target.value);
        setFreightChargeWOGst(+event.target.value);
        setFreightGstDetails({ ...freightGstDetails, rate: 0 });
        const procDetailObj = { ...procurementDetails };
        procDetailObj.grandTotal =
            procDetailObj?.grandTotal - freightCharge + +event.target.value;
        // procDetailObj.freight = +event.target.value;

        setProcurementDetails(procDetailObj);
        setEditableFields({
            ...editableFields,
            freightCharge: +event.target.value,
        });
    };

    // Function to Open Remarks Modal
    const openRemarksModalHandler = (status) => {
        if (status === "Approved") {
            setTextContent("Approval");
            setOpenApproveRemarksModal(true);
        }
        if (status === "Rejected") {
            setTextContent("Rejection");
            setOpenRejectRemarksModal(true);
        }
        setValue(status);
    };
    */

    // Funtion to close approve Remarks Modal
    const closeApproveRemarksModalHandler = () => {
        setOpenApproveRemarksModal(false);
        setRemarks("");
    };

    // Funtion to close reject Remarks Modal
    const closeRejectRemarksModalHandler = () => {
        setOpenRejectRemarksModal(false);
        setRejectionReason("");
        setRemarks("");
    };

    /*
    // Funtion to get type of the file do display
    const getFileType = (url) => {
        const extension = url?.split(".").pop()?.toLowerCase();
        if (extension === "pdf") {
            return "pdf";
        } else if (
            extension === "jpg" ||
            extension === "jpeg" ||
            extension === "png" ||
            extension === "gif"
        ) {
            return "image";
        } else {
            return "unknown";
        }
    };
    */

    const csvAprroveDownloadHandler = async () => {
        try {
          const response = await HttpService.getApprovalDataofInwardingCsv(startDate,endDate);
          
          const blob = new Blob(
            [response.data],
            { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }
          );
      
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = 'PO_Inwarding_approved.xlsx';
          document.body.appendChild(a);
          a.click();
          a.remove();
          window.URL.revokeObjectURL(url);
        } catch (error) {
          console.error("Excel download failed", error);
          alert("Failed to download Excel file.");
        }
      };
    // function to download data in csv
    const csvDownloadHandler = async () => {
        setLoading(true);
        try {
            let csvArray = [];

            for (let i = 0; i < dataForNewInwardingApproval.length; i++) {
                let obj = {
                    orderId: dataForNewInwardingApproval[i]?.procurementId?.orderId || "N/A",
                    inwardingId:
                        dataForNewInwardingApproval[i]?.InwardingRecords?.inwardingId ||
                        "N/A",
                    inwardedDate: dateFormatter(
                        dataForNewInwardingApproval[i]?.InwardingRecords?.dateOfInwarded || ""
                    ),
                    invoiceDate: dateFormatter(
                        dataForNewInwardingApproval[i]?.InwardingRecords?.invoiceDate || ""
                    ),
                    invoiceNumber:
                        dataForNewInwardingApproval[i]?.InwardingRecords?.invoiceNumber,
                    poQty: dataForNewInwardingApproval[i]?.poQuantity?.toFixed(2),
                    inwardedQty:
                        dataForNewInwardingApproval[i]?.InwardingRecords?.inwardedQty.toFixed(
                            2
                        ),
                    gst: dataForNewInwardingApproval[i]?.gstDetails[0]?.gstRate,
                    freightCharges: dataForNewInwardingApproval[i]?.freightCharges,
                    DateOfApproval:  "NA",
                    Status:"Pending",          
                    totalValue: dataForNewInwardingApproval[i]?.poValue?.toFixed(2),
                };
                csvArray.push(obj);
                obj = {
                    orderId: "",
                    inwardingId: "",
                    inwardedDate: "",
                    invoiceDate: "",
                    invoiceNumber: "",
                    poQty: "",
                    inwardedQty: "",
                    gst: "",
                    freightCharges: "",
                    DateOfApproval: "",
                    totalValue: "",
                };
                csvArray.push(obj);
            }
            setCsvData(csvArray);
            downloadExcel();
        } catch (error) {
            console.error("error", error);
            props?.setSnackInfo(
                error?.response?.data?.message ?? "Something went wrong",
                "error"
            );
        }
        setLoading(false);
    };

    // a helper function for csv download
    const downloadExcel = () => {
        setLoading(true);
        try {
            setTimeout(() => {
                csvButtonRef.current.link.click();
            });
        } catch (err) {
            console.error(err.message);
        }
        setLoading(false);
    };

    // function to format date
    const dateFormatter = (inputDate) => {
        if (inputDate === "") return "N/A";
        const date = new Date(inputDate);
        const day = date.getDate();
        const month = date.getMonth() + 1;
        const year = date.getFullYear();

        const formattedDay = day < 10 ? "0" + day : day;
        const formattedMonth = month < 10 ? "0" + month : month;

        const formattedDate = formattedDay + "-" + formattedMonth + "-" + year;
        return formattedDate;
    };

    // function to clear date filter
    const clearFilterDate = (e) => {
        props.setLoading(true);
        setStartDate("");
        setEndDate("");
        setSearchQuery("");
        setSearchType("")
        setfilterType("Pending")
        // setDataToDisplay(dataForNewInwardingApproval);
        getDataForInwardingApprovals("", "", 0, 100);
        props.setLoading(false);
    };

    // filter function for date range
    const inwardedDataOnSelectedDateHandler = () => {
        props.setLoading(true);
        if (startDate && endDate) {
            /*
            const filteredArray = dataForNewInwardingApproval.filter((el) => {
                let itemDate = new Date(el.InwardingRecords.dateOfInwarded);
                let selectedStartDate = new Date(startDate);
                let selectedEndDate = new Date(endDate);
                let adjustedEndDate = new Date(selectedEndDate);
                adjustedEndDate.setDate(adjustedEndDate.getDate() + 1);

                // Extract the date part only for comparison
                itemDate.setHours(0, 0, 0, 0);
                selectedStartDate.setHours(0, 0, 0, 0);
                adjustedEndDate.setHours(0, 0, 0, 0);

                return (
                    itemDate >= selectedStartDate && itemDate < adjustedEndDate
                );
            });
            setDataToDisplay(filteredArray);
            */
            getDataForInwardingApprovals(startDate, endDate, page, rowsPerPage,searchType,searchQuery);
        }
        props.setLoading(false);
    };

    /*
    // function to handle the rejection reason
    const handleChooseRejectionReason = (event) => {
        try {
            setRejectionReason(event.target.value);
            if (event.target.value !== "OTHERS") {
                setRemarks(event.target.value);
            } else {
                setRemarks("");
            }
        } catch (error) {
            console.error("Error -> ", error);
        }
    };

    // function to open the all remarks dialog box
    const showAllRemarksHandler = () => {
        try {
            setOpenAllRemarksDailog(true);
        } catch (error) {
            console.error("Error -> ", error);
        }
    };
    */
    // function to download procurements
    const closePoInvoiceModalHandler = () => {
        try {
            setInvoiceModal(false);
            getDataForInwardingApprovals(startDate, endDate, page, rowsPerPage,searchType,searchQuery);
        } catch (error) {
            console.error("Error -> ", error);
        }
    };
    // Function to handle search
    const handleSearch = () => {
        if (!searchQuery.trim()) {
            props.setSnackInfo("Please enter a search query", "warning");
            return;
        }
        getDataForInwardingApprovals(startDate, endDate,page, rowsPerPage,searchType,searchQuery);
    };
    
    
    return (
        <div>
            <div
                style={{
                    marginBottom: 20,
                    alignItems: "center",
                    justifyContent: "center",
                }}
            >
                <Paper className={classes.paper}>
                    <center>
                        <h2>New Inwarding Approvals</h2>
                    </center>
                </Paper>
            </div>

            {/* Date Filter component */}
            <Paper style={{ padding: 10, marginBottom: 10 }}>
                <Grid
                    container
                    style={{ display: "flex", alignItems: "center" }}
                >
                    <Grid item md={3} xs={12}>
                        <TextField
                            id="date"
                            name="startDate"
                            label="From Inwarded Date"
                            type="date"
                            value={startDate}
                            onChange={(e) => setStartDate(e.target.value)}
                            InputLabelProps={{
                                shrink: true,
                            }}
                            fullWidth
                        // className={classes.textField}
                        />
                    </Grid>
                    <Grid item md={1} xs={12}></Grid>
                    <Grid item md={3} xs={12}>
                        <TextField
                            id="date"
                            name="endDate"
                            label="To Inwarded Date"
                            type="date"
                            value={endDate}
                            onChange={(e) => setEndDate(e.target.value)}
                            InputLabelProps={{
                                shrink: true,
                            }}
                            fullWidth
                        // className={classes.textField}
                        />
                    </Grid>
                    <Grid item md={3} xs={12}>
                        <Button
                            variant="contained"
                            disabled={!startDate || !endDate}
                            onClick={inwardedDataOnSelectedDateHandler}
                            style={{ marginLeft: 10 }}
                            className={(startDate && endDate) ? classes.submitButton : null}
                        >
                            Submit
                        </Button>
                    </Grid>
                    <Grid item md={2} xs={12}>
                        <Button
                            variant="contained"
                            onClick={clearFilterDate}
                            className={classes.clearButton}
                        >
                            Clear Filter
                        </Button>
                    </Grid>
                </Grid>
            </Paper>

                    {/* Search Filter component */}
                    <Paper style={{ padding: 10, marginBottom: 10 }}>
                <Grid container spacing={2} alignItems="center">
                    <Grid item md={2} xs={12}>
                        <FormControl fullWidth variant="outlined">
                            <TextField
                                select
                                label="Search By"
                                value={searchType}
                                onChange={(e) => {
                                    setSearchType(e.target.value);
                                    setSearchQuery(""); // Clear search when changing type
                                }}
                                variant="outlined"
                            >
                                <MenuItem value="PO">PO Number</MenuItem>
                                <MenuItem value="INVOICE">Invoice Number</MenuItem>
                            </TextField>
                        </FormControl>
                    </Grid>
                    <Grid item md={3} xs={12}>
                        <TextField
                            fullWidth
                            label={`Search ${searchType === "PO" ? "PO" : "Invoice"} Number`}
                            variant="outlined"
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                        />
                    </Grid>
                    <Grid item md={2} xs={12}>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={handleSearch}
                            className={classes.submitButton}
                            disabled={!searchQuery}
                        >
                            Search
                        </Button>
                    </Grid>
                    <Grid item md={2} xs={12}>
                                <FormControl fullWidth variant="outlined">
                                    <TextField
                                        select
                                        label="Search By"
                                        value={filterType}
                                        onChange={(e) => {
                                            setfilterType(e.target.value);
                                        }}
                                        variant="outlined"
                                    >
                                        <MenuItem value="Pending">PO Pending</MenuItem>
                                        <MenuItem value="Approval">PO Approved</MenuItem>
                                    </TextField>
                                </FormControl>
                    </Grid>
                       {/* Download CSV Button */}
                    <div style={{ display: "flex", alignItems: "center" }}>
                         
                    <CSVLink
                            headers={headers}
                            filename={
                                filterType === "Approval"?"PO_inwarding_Approved ":"PO_Inwarding_Pending " +
                                new Date().toLocaleDateString().replaceAll("/", "_") +
                                ".csv"
                            }
                            data={csvData}
                            ref={csvButtonRef}
                        />
                       {filterType === "Pending" && (  <Button
                            onClick={csvDownloadHandler}
                            style={{ margin: 10, backgroundColor: "#355025",color:"#FFF2EB" }}
                            variant="contained"
                        >
                            Download CSV
                        </Button>)}
                        {filterType === "Approval" && (
                            <Button
                                onClick={csvAprroveDownloadHandler}
                                style={{ margin: 10, backgroundColor: "#355025", color: "#FFF2EB" }}
                                variant="contained"
                            >
                                Download CSV
                            </Button>
                        )}
                    </div>
                </Grid>
            </Paper>

            {/* Table for displaying data sent for New Inwarding Approvals */}
            <TablePagination
                component="div"
                count={totalCount}
                page={page}
                onPageChange={(e, newPage) => setPage(newPage)}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={(e) => {
                    setRowsPerPage(parseInt(e.target.value, 10));
                    setPage(0);
                }}
                rowsPerPageOptions={[100, 150, 200, 250, { label: 'All', value: totalCount }]}
            />

            <TableContainer TableContainer component={Paper}>
                <Table
                    className={classes.table}
                    size="small"
                    aria-label="customized table"
                    stickyHeader
                >
                    <TableHead>
                        <TableRow>
                            <StyledTableCell>Sl No</StyledTableCell>
                            <StyledTableCell>PO No.</StyledTableCell>
                            <StyledTableCell>Inwarding Id</StyledTableCell>
                            <StyledTableCell>Raised By</StyledTableCell>
                            <StyledTableCell>Inwarded By</StyledTableCell>
                            <StyledTableCell>Inwarded Date</StyledTableCell>
                            <StyledTableCell>Invoice Date</StyledTableCell>
                            <StyledTableCell>Invoice No.</StyledTableCell>
                            <StyledTableCell>PO Qty</StyledTableCell>
                            <StyledTableCell>Inwarded Qty</StyledTableCell>
                            <StyledTableCell>GST</StyledTableCell>
                            <StyledTableCell>Freight Charges</StyledTableCell>
                            <StyledTableCell>Total PO Value</StyledTableCell>
                            <StyledTableCell>Action</StyledTableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {dataForNewInwardingApproval?.map((el, i) => {
                            return (
                                <StyledTableRow key={i + 1}>
                                    <StyledTableCell>{i + 1}</StyledTableCell>
                                    <StyledTableCell>
                                        {el?.procurementId?.orderId}
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        {el?.InwardingRecords?.inwardingId}
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        {el?.procurementId?.createdBy?.name || "N/A"}
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        {el?.procurementId?.inwardingBy?.name || "N/A"}
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        {moment(
                                            el?.InwardingRecords?.dateOfInwarded
                                        ).format("DD-MM-YYYY")}
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        {el?.InwardingRecords?.invoiceDate
                                            ? moment(
                                                el.InwardingRecords
                                                    .invoiceDate
                                            ).format("DD-MM-YYYY")
                                            : "N/A"}
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        {el?.InwardingRecords?.invoiceNumber}
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        {el?.poQuantity?.toFixed(2)}
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        {el?.InwardingRecords?.inwardedQty?.toFixed(
                                            2
                                        )}
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        {el?.gstDetails[0]?.gstRate?.toFixed(
                                            2
                                        ) || "N/A"}
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        {el?.InwardingRecords?.freightCharge?.toFixed(
                                            2
                                        ) || "N/A"}
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        {el?.poValue?.toFixed(2)}
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        <>
                                            <Button
                                                variant="contained"
                                                onClick={() =>
                                                    openInvoiceModalHandler(el)
                                                }
                                                className={classes.actionButton}
                                            >
                                                Action
                                            </Button>
                                            {/* <Button variant="contained" color="primary" style={{ background: "#f50057", margin: 5 }} onClick={() => handleSubmit('Rejected', el)}>
                                                Reject
                                            </Button> */}
                                        </>
                                    </StyledTableCell>
                                </StyledTableRow>
                            );
                        })}
                    </TableBody>
                </Table>
            </TableContainer>

            {invoiceModal && <DetailsModalOfInwarding DETAILS={details} CLOSE_MODAL_HANDLER={closePoInvoiceModalHandler} />}
            {/* PO Invoice Modal */}
            {/*
            <Modal
                aria-labelledby="alert-dialog-slide-title"
                aria-describedby="alert-dialog-slide-description"
                title={`New Inwarding Approval | ${selectedOrderId}`}
                centered
                open={invoiceModal}
                onCancel={() => setInvoiceModal(false)}
                width={1500}
                maskClosable={true}
                footer={null}
            >
                <div style={{ display: "flex", width: "100%" }}>
                    <div
                        style={{
                            border: "1px solid #000",
                            flex: 1,
                            padding: "2px",
                        }}
                    >
                        <div
                            className="container"
                            style={{ width: "100%", marginTop: "2%" }}
                        >
                            <div>
                                <div>
                                    <table>
                                        <tbody>
                                            <tr>
                                                <td
                                                    rowSpan="3"
                                                    style={{ width: "50%" }}
                                                >
                                                    <div className="invoice">
                                                        Invoice to:
                                                    </div>
                                                    <div className="invoice-to">
                                                        <b>
                                                            Samika Design
                                                            Solutions Pvt Ltd.
                                                        </b>
                                                        <div>
                                                            #17, 18th Cross Rd,
                                                            Sector 3, HSR
                                                            Layout, Bengaluru -
                                                            560102
                                                        </div>
                                                        <div className="gstno">
                                                            Gst
                                                            No-29AAWCS3842H1ZO
                                                        </div>
                                                        <div>
                                                            State Name :
                                                            Karnataka, Code : 29
                                                        </div>
                                                        <div>
                                                            E-Mail:
                                                            sales@decorpot.com
                                                        </div>
                                                    </div>
                                                </td>
                                                <td style={{ width: "25%" }}>
                                                    <div>Voucher No.</div>
                                                    <div className="vou-no">
                                                        <b>
                                                            {
                                                                procurementDetails?.orderId
                                                            }
                                                        </b>
                                                    </div>
                                                </td>
                                                <td style={{ width: "25%" }}>
                                                    <div>Dated:</div>
                                                    <div className="vou-no">
                                                        <b>
                                                            {moment(
                                                                procurementDetails?.createdAt
                                                            ).format(
                                                                "DD-MM-YYYY"
                                                            )}
                                                        </b>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td style={{ width: "25%" }}>
                                                    &nbsp;
                                                </td>
                                                <td style={{ width: "25%" }}>
                                                    <div>
                                                        Mode/Terms of Payment
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td style={{ width: "25%" }}>
                                                    <div>
                                                        Supplier's Ref./Order
                                                        No.
                                                    </div>
                                                    <div className="vou-no">
                                                        <b>
                                                            {
                                                                procurementDetails?.orderId
                                                            }
                                                        </b>
                                                    </div>
                                                </td>
                                                <td style={{ width: "25%" }}>
                                                    <div>
                                                        Other
                                                        Reference(s)/Comments
                                                    </div>
                                                    <div className="vou-no">
                                                        <b>
                                                            {
                                                                procurementDetails?.comment
                                                            }
                                                        </b>
                                                    </div>
                                                </td>
                                            </tr>

                                            <tr>
                                                <td
                                                    rowSpan="2"
                                                    style={{ width: "50%" }}
                                                >
                                                    <div className="invoice">
                                                        Supplier
                                                    </div>
                                                    <div className="invoice-to">
                                                        <b>
                                                            {
                                                                procurementDetails
                                                                    ?.vendorId
                                                                    ?.name
                                                            }
                                                        </b>
                                                        <div>
                                                            {
                                                                procurementDetails
                                                                    ?.vendorId
                                                                    ?.address
                                                            }
                                                        </div>
                                                        <div className="row">
                                                            <div
                                                                className="col-md-2"
                                                                style={{
                                                                    float: "left",
                                                                }}
                                                            >
                                                                GSTIN/UIN
                                                            </div>
                                                            <div className="col-md-10">
                                                                :&nbsp;
                                                                {
                                                                    procurementDetails
                                                                        ?.vendorId
                                                                        ?.gstinNumber
                                                                }
                                                            </div>
                                                            <div className="row">
                                                                <div
                                                                    className="col-md-2"
                                                                    style={{
                                                                        float: "left",
                                                                    }}
                                                                >
                                                                    State Name
                                                                </div>
                                                                <div className="col-md-10">
                                                                    :&nbsp;Karnataka,
                                                                    Code : 29
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div>Inwarding Id</div>
                                                    <div className="vou-no">
                                                        <b>
                                                            {
                                                                details
                                                                    ?.InwardingRecords
                                                                    ?.inwardingId
                                                            }
                                                        </b>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div>
                                                        <Button
                                                            variant="outlined"
                                                            onClick={
                                                                showAllRemarksHandler
                                                            }
                                                            color="secondary"
                                                        >
                                                            Show Remarks
                                                        </Button>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td colSpan="1">
                                                    <div>Terms of Delivery</div>
                                                </td>
                                                <td style={{ width: "25%" }}>
                                                    <div>Invoice No.</div>
                                                    <div className="vou-no">
                                                        <b>
                                                            {
                                                                details
                                                                    ?.InwardingRecords
                                                                    ?.invoiceNumber
                                                            }
                                                        </b>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>

                                <div>
                                    <Table
                                        size="small"
                                        aria-label="custom pagination table"
                                    >
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>Sl. No.</TableCell>
                                                <TableCell>
                                                    Description of Goods
                                                </TableCell>
                                                <TableCell>Due On</TableCell>
                                                <TableCell>Quantity</TableCell>
                                                <TableCell>Rate</TableCell>
                                                <TableCell>per</TableCell>
                                                <TableCell>Disc. %</TableCell>
                                                <TableCell>Amount</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableHead>
                                            {procurementDetails?.materials?.map(
                                                (material, index) =>
                                                    material.isAdded && (
                                                        <TableRow key={index}>
                                                            <TableCell>
                                                                {index + 1}
                                                            </TableCell>
                                                            <TableCell>
                                                                <div>
                                                                    <b>
                                                                        {
                                                                            material
                                                                                ?.materialId
                                                                                ?.code
                                                                        }
                                                                    </b>
                                                                </div>
                                                                <br />
                                                                <div className="desc">
                                                                    [
                                                                    {material
                                                                        ?.materialId
                                                                        ?.aliasName
                                                                        ? material
                                                                              ?.materialId
                                                                              ?.aliasName
                                                                        : material
                                                                              ?.materialId
                                                                              .name}
                                                                    ]
                                                                </div>
                                                                <br />
                                                                {material?.remark && (
                                                                    <div className="desc">
                                                                        {
                                                                            material?.remark
                                                                        }
                                                                    </div>
                                                                )}
                                                            </TableCell>
                                                            <TableCell>
                                                                45 Days
                                                            </TableCell>
                                                            <TableCell>
                                                                {
                                                                    details
                                                                        ?.InwardingRecords
                                                                        ?.inwardedQty
                                                                }
                                                            </TableCell>
                                                            <TableCell>
                                                                <FormControl
                                                                    style={{
                                                                        width: 200,
                                                                    }}
                                                                >
                                                                    <TextField
                                                                        style={{
                                                                            margin: "5px",
                                                                        }}
                                                                        size="small"
                                                                        id={`requestedPrice-${index}`}
                                                                        label="Requested Price"
                                                                        value={
                                                                            material?.requestedPrice
                                                                        }
                                                                        variant="outlined"
                                                                        name={`requestedPrice-${index}`}
                                                                        type="number"
                                                                        onChange={(
                                                                            e
                                                                        ) =>
                                                                            materialPriceChangeHandler(
                                                                                index,
                                                                                e
                                                                            )
                                                                        }
                                                                    />
                                                                </FormControl>
                                                            </TableCell>
                                                            <TableCell>
                                                                {
                                                                    material
                                                                        ?.unitId
                                                                        .name
                                                                }
                                                            </TableCell>
                                                            <TableCell>
                                                                {
                                                                    procurementDetails?.discount
                                                                }
                                                            </TableCell>
                                                            <TableCell>
                                                                ₹
                                                                {(
                                                                    material?.materialTotal?.toFixed(
                                                                        2
                                                                    ) -
                                                                    (procurementDetails?.discount *
                                                                        material?.materialTotal) /
                                                                        100
                                                                ).toFixed(2)}
                                                            </TableCell>
                                                        </TableRow>
                                                    )
                                            )}
                                        </TableHead>
                                    </Table>
                                </div>

                                <div>
                                    <Table>
                                        <TableBody>
                                            <TableRow key="1">
                                                <TableCell>Total Qty</TableCell>
                                                <TableCell>
                                                    {
                                                        procurementDetails?.totalQty
                                                    }
                                                </TableCell>
                                            </TableRow>
                                            <TableRow key="2">
                                                <TableCell>
                                                    Freight Approved (W/O GST)
                                                </TableCell>
                                                <TableCell>
                                                    ₹
                                                    {procurementDetails?.totalFreightApproved?.toFixed(
                                                        2
                                                    )}
                                                </TableCell>
                                            </TableRow>
                                            <TableRow key="3">
                                                <TableCell>
                                                    <i>Freight Charge</i>
                                                </TableCell>
                                                <TableCell>
                                                <Box display="flex" alignItems="center" justifyContent="space-between">
                                                        <FormControl style={{ width: '48%' }}>
                                                            <TextField
                                                                style={{ margin: '5px' }}
                                                                size="small"
                                                                id="outlined-basic"
                                                                label="Freight Charge"
                                                                value={freightCharge}
                                                                variant="outlined"
                                                                name="freight charge"
                                                                type="number"
                                                                onChange={(e) => freightChargesChangeHandler(e)}
                                                            />
                                                        </FormControl>
                                                        <Autocomplete
                                                            value={freightGstDetails?.rate}
                                                            onChange={(e, value) => freightGstRateChangeHandler(e, value)}
                                                            id="percent"
                                                            options={freightGstPercent}
                                                            getOptionLabel={(option) => `${option}%`}
                                                            style={{ width: '48%' }}
                                                            renderInput={(params) => <TextField {...params} label="Select GST percent for Freight" fullWidth variant="outlined" />}
                                                        />
                                                    </Box>
                                                </TableCell>
                                            </TableRow>
                                            <TableRow key="4">
                                                <TableCell>
                                                    <i>GST Rate</i>
                                                </TableCell>
                                                <TableCell>
                                                    {procurementDetails?.gstDetails
                                                        ? procurementDetails
                                                              .gstDetails
                                                              .length !== 0
                                                            ? procurementDetails
                                                                  .gstDetails[0]
                                                                  .rate
                                                                ? procurementDetails
                                                                      .gstDetails[0]
                                                                      .rate
                                                                : "N/A"
                                                            : "N/A"
                                                        : "N/A"}
                                                    %
                                                </TableCell>
                                            </TableRow>
                                            <TableRow key="5">
                                                <TableCell>
                                                    <i>Gst Charge</i>
                                                </TableCell>
                                                <TableCell>
                                                    {gstAmounts?.toFixed(2)}
                                                </TableCell>
                                            </TableRow>
                                            <TableRow key="6">
                                                <TableCell>
                                                    Total Amount
                                                </TableCell>
                                                <TableCell>
                                                    ₹
                                                    {procurementDetails?.grandTotal?.toFixed(
                                                        2
                                                    )}
                                                </TableCell>
                                            </TableRow>
                                        </TableBody>
                                    </Table>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        style={{
                            border: "1px solid #000",
                            flex: 1,
                            padding: "",
                        }}
                    >
                        {
                            // Display pdf when file type is pdf
                            getFileType(details?.InwardingRecords?.invoice) ===
                            "pdf" ? (
                                <iframe
                                    title="PDF Viewer"
                                    src={`https://docs.google.com/gview?url=${details?.InwardingRecords?.invoice}&embedded=true`}
                                    style={{
                                        width: "fit-content",
                                        height: "800px",
                                        border: "none",
                                    }}
                                ></iframe>
                            ) : // Display image when file is image
                            getFileType(details?.InwardingRecords?.invoice) ===
                              "image" ? (
                                <img
                                    src={details?.InwardingRecords?.invoice}
                                    width="100%"
                                    alt="Image"
                                ></img>
                            ) : (
                                // Display warning when file type is not supported
                                <p style={{ color: "red", padding: "10%" }}>
                                    <b>File Format Not Supported</b>
                                </p>
                            )
                        }
                    </div>
                </div>

                <DialogActions>
                    <Button
                        onClick={() => openRemarksModalHandler("Rejected")}
                        color="secondary"
                        variant="outlined"
                    >
                        Reject
                    </Button>
                    <Button
                        onClick={() => openRemarksModalHandler("Approved")}
                        color="primary"
                        variant="contained"
                        style={{ background: "#2b7636", margin: 5 }}
                    >
                        Approve
                    </Button>
                </DialogActions>
            </Modal>
            */}

            {/* Approve Remarks Dialog Box  */}
            <div>
                <Dialog
                    open={openApproveRemarksModal}
                    onClose={closeApproveRemarksModalHandler}
                    aria-labelledby="form-dialog-title"
                    maxWidth="sm"
                    fullWidth
                >
                    <DialogContent>
                        <DialogContentText>
                            Enter {textContent} Remarks
                        </DialogContentText>
                        <TextField
                            id="remarks"
                            name="Remarks"
                            label="Add Remarks"
                            variant="outlined"
                            type="text"
                            value={remarks}
                            onChange={remarksInputHandler}
                            fullWidth
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button
                            variant="outlined"
                            onClick={closeApproveRemarksModalHandler}
                            color="secondary"
                        >
                            Cancel
                        </Button>
                        <Button
                            onClick={handleFinanceInwardingAction}
                            variant="contained"
                            color="primary"
                            style={{ background: "#2b7636", margin: 5 }}
                        >
                            Submit
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>

            {/* Reject Remarks Dialog Box  */}
            {/*
            <div>
                <Dialog
                    open={openRejectRemarksModal}
                    onClose={closeRejectRemarksModalHandler}
                    aria-labelledby="form-dialog-title"
                    maxWidth="sm"
                    fullWidth
                >
                    <DialogContent>
                        <DialogContentText>
                            Choose {textContent} Reason
                        </DialogContentText>
                        <FormControl
                            style={{ width: "100%", marginTop: "0.4rem" }}
                        >
                            <TextField
                                select
                                labelId="project-doc"
                                label="Choose Rejection Reason"
                                variant="outlined"
                                value={rejectionReason}
                                onChange={(e) => handleChooseRejectionReason(e)}
                            >
                                <MenuItem value="QUANTITY">Quantity</MenuItem>
                                <MenuItem value="GST">GST</MenuItem>
                                <MenuItem value="FREIGHT">Freight</MenuItem>
                                <MenuItem value="AMOUNT">Amount</MenuItem>
                                <MenuItem value="OTHERS">Others</MenuItem>
                            </TextField>
                        </FormControl>
                        {rejectionReason === "OTHERS" && (
                            <>
                                <DialogContentText>
                                    Enter {textContent} Remarks
                                </DialogContentText>
                                <TextField
                                    id="remarks"
                                    name="Remarks"
                                    label="Add Remarks"
                                    variant="outlined"
                                    type="text"
                                    value={remarks}
                                    onChange={remarksInputHandler}
                                    fullWidth
                                />
                            </>
                        )}
                    </DialogContent>
                    <DialogActions>
                        <Button
                            variant="outlined"
                            onClick={closeRejectRemarksModalHandler}
                            color="secondary"
                        >
                            Cancel
                        </Button>
                        <Button
                            onClick={handleFinanceInwardingAction}
                            variant="contained"
                            color="primary"
                            style={{ background: "#2b7636", margin: 5 }}
                        >
                            Submit
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
            */}

            {/* All Remarks Display Dialog Box  */}
            {/*
            <div>
                <Dialog
                    open={openAllRemarksDailog}
                    onClose={() => setOpenAllRemarksDailog(false)}
                    aria-labelledby="form-dialog-title"
                    maxWidth="md"
                    fullWidth
                >
                    <DialogContent>
                        <DialogContentText>Remarks</DialogContentText>
                        <Table
                            className={classes.table}
                            size="small"
                            aria-label="customized table"
                            stickyHeader
                        >
                            <TableHead>
                                <TableRow>
                                    <StyledTableCell>Action</StyledTableCell>
                                    <StyledTableCell>Remarks</StyledTableCell>
                                    <StyledTableCell>
                                        Remarks Date
                                    </StyledTableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {details?.InwardingRecords?.remarks?.length >
                                0 ? (
                                    details?.InwardingRecords?.remarks.map(
                                        (el, i) => {
                                            return (
                                                <TableRow key={i + 1}>
                                                    <StyledTableCell>
                                                        {el?.action}
                                                    </StyledTableCell>
                                                    <StyledTableCell>
                                                        {el?.msgBody}
                                                    </StyledTableCell>
                                                    <StyledTableCell>
                                                        {new Date(
                                                            el.date
                                                        ).toLocaleDateString()}
                                                    </StyledTableCell>
                                                </TableRow>
                                            );
                                        }
                                    )
                                ) : (
                                    <p>No Remarks To Show</p>
                                )}
                            </TableBody>
                        </Table>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            variant="outlined"
                            onClick={() => setOpenAllRemarksDailog(false)}
                            color="secondary"
                        >
                            Close
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
            */}
        </div>
    );
};

export default connect(null, { setLoading, setSnackInfo })(
    NewInwardingApproval
);